define.alias("shared/helpers/format-number-to-locale-string", "calendar/helpers/format-number-to-locale-string");